import React from 'react';
import PageWrapper from './PageWrapper';
import styled from 'styled-components'
import Utils from './Utils'

import { InputTextBox, FormField, SubmitRow, SessionTextArea, FormLabel, MixerLogo, MixerlabText  } from './Components'
import { SessionClickableContainer, RowFlexDiv } from './Components';

const SlackInstructions = (
<ul>
  <li>Our Data labelling is done through Slack. Slack labellers are tiered according to quality and have to earn they way into higher tiers. You can monitor ongoing tasks through this slack interface</li>
  <li>Note that you must be added to the MixerLab slack, and have access to the experimentation-channel, to see all the tasks. Please ask mixerlab slack admins (Voice Team + Cole) if this is something you need and don't have.</li>
  <li>A 'TaskSpec' is a defined set of instructions required to completely spec a slack labelling task. They are saved as JSONs to gs://mixer-scriber-storage/mixer-lab/taskspecs. The jsons in this bucket are ground truth so if you hand-make one and upload it, thats also fine, but not recommended as we cannot guarantee well-formed tasks this way. It can be helpful for copy-pasting templates that you can then edit. All taskspecs come up under 'dormant tasks'. All active tasks can be monitored through 'active tasks'.</li>
  <li>Slack tasks are served to users in the MixerLab Slack, you can control what tier of user they get shown to, how much you pay per task, and the format. It is highly recommended to kick off a task in the Gridspace/experimentation/ADMIN tier and test it before you release it to users.</li>
  <li>Here is a diagram of our process for serving data points from redis to slack. There is a different process for Normal Tasks and Training Tasks, since training tasks should be completed in order and datapoints should never be "claimed" by someone, whereas for normal tasks we want datapoints to only be 'held' by one person at a time.</li>
  <img src='https://storage.googleapis.com/mixerlab-cdn/slack_diagram.png' style={{ width: '100%', height: 'auto' }}/>
</ul>
)

class SlackAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dormantTasks: '',
      activeTasks: '',
      showInstructions: false,
      user_training_emails: '', 
      user_training_tier: '', 
      sid_list: '',
      session_name: '',
      load_session_name: '', 
      model: 'asr',
      speaker_roles: 'agent,caller',
      sift_realm: 'api',
      sift_tempkey: '',
      message: ''
    }
  }

  componentDidMount() {
    this.setState({
      'dormantTasks': this.props.dormantTasks,
      'activeTasks': this.props.activeTasks
    })
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    
    let data = {
      'email': this.state.user_training_emails, 
      'training_tier': this.state.user_training_tier
    };
    Utils.apiPost("/slack/assign_training/", data)
      .then((response) => {
          console.log(response)
          this.setState({message: response.data["message"]})
        }
      )
  };

  handleCreateTask(e) {
    e.preventDefault();
    e.stopPropagation();
    
    let data = {
      'sid_list': this.state.sid_list.split('\n'), 
      'session_name': this.state.session_name,
      'speaker_roles': this.state.speaker_roles.split(','),
      'model': this.state.model,
      'sift_realm': this.state.sift_realm,
      'sift_tempkey': this.state.sift_tempkey
    };
    Utils.apiPost("/slack/submit_transcription_task/", data)
      .then((response) => {
          console.log(response)
          this.setState({message: response.data["result"]})
        }
      )
    if (this.state.message === 'success') {
      window.location.reload()
    }
  }

  handleLoadTranscripts(e) {
    e.preventDefault();
    e.stopPropagation();

    let url = '/slack/load_human_transcripts/' + this.state.load_session_name
    Utils.apiPost(url)
      .then((response) => {
          console.log(response)
          this.setState({message: response.data["result"]})
        }
      )
    if (this.state.message === 'success') {
      window.location.reload()
    }
  }

  linkFor(task_id) {
    let url = '/slack/taskspec/' + task_id
    return (
        <li><a href={url}>{task_id.replaceAll('[', '').replaceAll(']', '')}</a></li>
      )
    }

  render() {
    return (
      <PageWrapper isAdmin={this.props.isAdmin}>
        <h1>Slack Admin Page</h1>
        {this.state.showInstructions && <MixerlabText>{SlackInstructions}</MixerlabText>}
        <button style={{'margin': '20px'}} onClick={() => this.setState({showInstructions: !this.state.showInstructions})}>Show README</button>
        <FormLabel><h2>Active Tasks:</h2></FormLabel>
        {(this.state.activeTasks !== '') &&
          <ul>
            {this.state.activeTasks.split(', ').map((task_id) => {return(this.linkFor(task_id))})}
          </ul>
        }
        <FormLabel><h2>Dormant Tasks:</h2></FormLabel>
        <ul>
          {this.state.dormantTasks.split(', ').map((task_id) => {return(this.linkFor(task_id))})}
        </ul>
        <FormLabel><h2>New Tasks:</h2></FormLabel>
        <SessionClickableContainer onClick={() => window.location.href='/slack/taskspec/'}>
          <RowFlexDiv><MixerLogo /></RowFlexDiv>
          Create New Task
        </SessionClickableContainer>
        <FormLabel><h2>Learning Management:</h2></FormLabel>
        <div style={{width: '100%'}}>
          <FormField label='Enter the User Email:'>
            <SessionTextArea
              name="user_training_emails"
              placeholder="This is the email associated with the user's MixerLab account. Enter multiple as comma separated if desired."
              value={this.state.user_training_emails}
              onChange={(event) => {this.setState({ user_training_emails: event.target.value })}}
            />
          </FormField>
          <FormField label='Enter the name of the tier. Trainings associated with this tier will be assigned to the user.'>
              <select id="tier" name="is_training" value={this.state.user_training_tier}
                onChange={(event) => {this.setState({ user_training_tier: event.target.value })}}>
                <option value={'provisional'}>Provisional</option>
                <option value={'rookie'}>Rookie</option>
                <option value={'enthusiast'}>Enthusiast</option>
                <option value={'expert'}>Expert</option>
                <option value={'influencer'}>Influencer</option>
                <option value={'maestro'}>Maestro</option>
            </select>
          </FormField>
          <SubmitRow>
            <button type="submit" onClick={e => this.handleSubmit(e)}>
              Assign Training
            </button>
          </SubmitRow>
          {this.state.message && <div>{this.state.message}</div>}
        </div>
        <FormLabel><h2>Create Transcription Tasks</h2></FormLabel>
        <div style={{width: '100%'}}>
          <FormField label='SIDs:'>
            <SessionTextArea
              name="sid_list"
              placeholder="Newline Separated SIDS"
              value={this.state.sid_list}
              onChange={(event) => {this.setState({ sid_list: event.target.value })}}
            />
          </FormField>
          <FormField label='Session Name:'>
            <InputTextBox
              name="session_name"
              placeholder=""
              value={this.state.session_name}
              onChange={(event) => {this.setState({ session_name: event.target.value })}}
            />
          </FormField>
          <FormField label='Speaker Roles for Task:'>
              <select id="speaker_roles" name="speaker_roles" value={this.state.speaker_roles}
                onChange={(event) => {this.setState({ speaker_roles: event.target.value })}}>
                <option value={'caller, agent'}>All Speakers</option>
                <option value={'caller'}>Caller Only</option>
                <option value={'agent'}>Agent Only</option>
            </select>
          </FormField>
          <FormField label='Model Bucket Directory:'>
              <select id="model" name="model" value={this.state.model}
                onChange={(event) => {this.setState({ model: event.target.value })}}>
                <option value={'tts'}>TTS</option>
                <option value={'asr'}>ASR/Other Transcription</option>
            </select>
          </FormField>
          <FormField label='Sift Realm:'>
            <InputTextBox
              name="sift_realm"
              placeholder=""
              value={this.state.sift_realm}
              onChange={(event) => {this.setState({ sift_realm: event.target.value })}}
            />
          </FormField>
          <FormField label='Sift Tempkey (if not Mixer or TTS API Accounts):'>
            <InputTextBox
              name="sift_tempkey"
              placeholder=""
              value={this.state.sift_tempkey}
              onChange={(event) => {this.setState({ sift_tempkey: event.target.value })}}
            />
          </FormField>
          <SubmitRow>
            <button type="submit" onClick={e => this.handleCreateTask(e)}>
              Create Task
            </button>
          </SubmitRow>
          {this.state.message && <div>{this.state.message}</div>}
        </div>
        <FormLabel><h2>Load Human Transcripts</h2></FormLabel>
        <div style={{width: '100%'}}>
          <FormField label='Session Name:'>
            <SessionTextArea
              name="load_transcript_session_name"
              placeholder=""
              value={this.state.load_session_name}
              onChange={(event) => {this.setState({ load_session_name: event.target.value })}}
            />
          </FormField>
          <SubmitRow>
            <button type="submit" onClick={e => this.handleLoadTranscripts(e)}>
              Load Transcripts
            </button>
          </SubmitRow>
          {this.state.message && <div>{this.state.message}</div>}
        </div>
      </PageWrapper>
    );
  }
}

export default SlackAdmin;